<template>
  <v-dialog persistent v-model="dia">

    <v-card>

      <v-card-title class="pa-0">
        <v-toolbar flat>
          <v-toolbar-title>This page is under constuction, join our discord to see our current servers</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
      </v-card-title>



      <v-card-actions>
        <v-btn to="/">Back to home</v-btn>
        <v-btn href="https://discord.gg/ChT5bJasg4" target="_blank">Discord <v-icon class="ml-2">mdi-discord</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {


    data: ()=> {
    return{
        dia:true
    }
}

}

</script>

<style>

</style>